// 建議價格與目前價格都是「多個日期 × 該類型底下多個房型」的平均值，
// 絕對金額無法對照到任何一個個別房型的定價，所以儀錶板改以百分比幅度呈現 ——
// 使用者才有辦法把幅度套用到自己的每一個房型上。

export const ADJUST_UP_COLOR = '#EB5757';
export const ADJUST_DOWN_COLOR = '#27AE60';
export const ADJUST_FLAT_COLOR = '#828282';

const isUsablePrice = (value) =>
  typeof value === 'number' && Number.isFinite(value);

const withThousands = (value) =>
  String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * 算出建議價相對於目前價的調整金額與幅度。
 *
 * 任一價格缺漏、或目前價不是正數時兩個值都回 null，代表「算不出來」。
 * 不回 0：0 的語意是「持平」，跟「沒有資料」是兩件事，混在一起會讓
 * 儲存格把缺資料的格子畫成持平。
 */
export function calcPriceAdjust(currentprice, recommendprice) {
  if (!isUsablePrice(currentprice) || !isUsablePrice(recommendprice)) {
    return { amount: null, rate: null };
  }
  if (currentprice <= 0) {
    return { amount: null, rate: null };
  }
  const amount = recommendprice - currentprice;
  return { amount, rate: amount / currentprice };
}

/**
 * 比率格式化成標籤上的百分比。取絕對值 —— 方向交給箭頭表達，
 * 否則會出現「▼ -8.3%」這種雙重否定。
 */
export function formatAdjustRate(rate) {
  if (rate === null || rate === undefined) return null;
  return `${(Math.abs(rate) * 100).toFixed(1)}%`;
}

/**
 * 金額格式化成 tooltip 文字，帶正負號。
 */
export function formatAdjustAmount(amount) {
  if (amount === null || amount === undefined) return null;
  const sign = amount > 0 ? '+' : '';
  return `${sign}${withThousands(amount)} 元`;
}

/**
 * 建議價格文字的顏色。算不出調幅時回 undefined 讓文字維持預設色。
 */
export function adjustColor(rate) {
  if (rate === null || rate === undefined) return undefined;
  if (rate > 0) return ADJUST_UP_COLOR;
  if (rate < 0) return ADJUST_DOWN_COLOR;
  return ADJUST_FLAT_COLOR;
}
